import styled from "styled-components";
import { colors } from "../../components/helpers/functions";

export const WrapperStyled = styled.div`

`
export const LoaderStyled = styled.div`
    .loader{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 53px;
        padding-top: 30px;
        margin-bottom: 30px;
        svg{
            color: rgba(${colors.verde_acelga}, 1);
        }
    }
`
export const BoxProduct = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    //height: 250px;
    .loader{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 53px;
        svg{
            color: rgba(${colors.verde_acelga}, 1);
        }
    }
    .quiz_complete{
        width: 100%;
        text-align: center;
        font-size: 5vw;
        font-weight: 600;
    }
    .santo_padre_quiz_complete,
    .gallinas_quiz_complete,
    .pan_batard_quiz_complete{
        margin-top: 5vw;
        margin-bottom: 5vw;
        padding-top: 3vw;
        padding-bottom: 3vw;
        border-bottom: 1px solid rgba(${colors.marron_tierra}, 1);
        border-top: 1px solid rgba(${colors.marron_tierra}, 1);
    }
    .pan_batard_quiz_complete{
        border-bottom: 1px solid rgba(${colors.blanco_huevo}, 1);
        border-top: 1px solid rgba(${colors.blanco_huevo}, 1);
        margin-bottom: 0;
    }
    .fresh_quiz_complete{
        border-bottom: 1px solid rgba(${colors.blanco_huevo}, 1);
        border-top: 1px solid rgba(${colors.blanco_huevo}, 1);
        margin-top: 5vw;
        margin-bottom: 5vw;
        padding-top: 3vw;
        padding-bottom: 3vw;
    }
    .resena_quiz_complete{
        border-bottom: 1px solid rgba(${colors.blanco_huevo}, 1);
        border-top: 1px solid rgba(${colors.blanco_huevo}, 1);
        margin-top: 5vw;
        padding-top: 3vw;
        padding-bottom: 3vw;
    }
    .gallinas_quiz_complete{
        margin-bottom: 0;
        margin-top: 0;
    }
    &.producto_santo_padre{
        .box{
            .actions{
                margin-top: 6vw;
                margin-bottom: 8vw!important;
            }
        }
    }
    &.producto_siete_cabritos{
        .box{
            .actions{
                margin-top: 6vw;
                //margin-bottom: 8vw!important;
            }
        }
    }
    &.producto_pan_batard{
        .box{
            .actions{
                margin-top: 6vw;
                //margin-bottom: 8vw!important;
            }
        }
    }
    &.producto_fresh{
        .box{
            .actions{
                margin-top: 6vw;
                margin-bottom: 2vw!important;
            }
        }
    }
    &.producto_caja{
        .box{
            .actions{
                margin-top: 6vw;
                margin-bottom: 2vw!important;
            }
            .gracias_por_visitarnos{
                width: 100%;
                font-size: 9vw!important;
                line-height: 9.5vw!important;
                font-weight: 900!important;
                text-transform: uppercase;
                text-align: center;
            }
            .feedback{
                margin-top: 4vw;
                text-align: center;
            }
        }
    }
    .video{
        display: flex;
        video{
            display: flex;
        }
    }
    p{
        padding: 0;
        margin: 0;
    }
    .box{
        width: 100%;
        .inner{
            padding: 10vw 8vw;
            .quesos{
                font-size: 7vw;
                line-height: 7vw;
                font-weight: 800;
                
            }
            .santo_padre{
                font-size: 10vw;
                line-height: 10vw;
                font-weight: 900;
                color: #FFFFFF;
            }
            .p1{
                color: #FFFFFF;
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                margin-top: 4vw;
            }
            .p2{
                color: #FFFFFF;
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                .divertirse{
                    font-weight: 700!important;
                }
                .destaca{
                    //font-weight: 700;
                }
            }
            .p3{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                margin-top: 4vw;
                .destaca{
                    //font-weight: 700;
                    //color: rgba(${colors.naranja_pimiento}, 1);
                }
            }
            .p4{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                color: #FFFFFF;
                .destaca{
                    //font-weight: 700;
                    //color: rgba(${colors.amarillo_banana}, 1);
                }
            }
            .p5{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                color: rgba(${colors.blanco_huevo}, 1);
                margin-top: 4vw;
                .destaca{
                    //font-weight: 700;
                }
            }
            .p6{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                .destaca{
                    //font-weight: 700;
                }
            }
            .p7{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                margin-top: 4vw;
                .destaca{
                    //font-weight: 700;
                }
            }
            .p8{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                .destaca{
                    //font-weight: 700;
                }
            }
            .p9{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                .destaca{
                    //font-weight: 700;
                }
            }
            .p10{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                //margin-top: 8vw;
                .destaca{
                    //font-weight: 700;
                }
            }
            .p11{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                .destaca{
                    //font-weight: 700;
                }
            }
            .p12{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                //margin-top: 2vw;
                .destaca{
                    //font-weight: 700;
                }
            }
            .p13{
                font-size: 4vw;
                line-height: 5.2vw;
                font-weight: 500;
                margin-top: 7vw;
                .destaca{
                    //font-weight: 700;
                }
            }
            
            &.fresh{
                >.title{
                    display: flex;
                    flex-direction: row;
                }
            }
            &.conoce_gallinas{
                >.title{
                    display: flex;
                    flex-direction: column;
                }
            }
            &.pan_batard{
                >.title{
                    display: flex;
                    flex-direction: column;
                }
            }
            &.siete_cabritos{
                >.title{
                    font-size: 13vw;
                    line-height: 12vw;
                    font-weight: 900;
                    display: flex;
                    flex-direction: column;
                }
            }
            .smoothies{
                font-size: 8vw;
                line-height: 8vw;
                font-weight: 900;
            }
            .alif{
                font-size: 12vw;
                line-height: 12vw;
                font-weight: 900;
            }
            .secreto{
                font-size: 5.5vw;
                line-height: 5.5vw;
                font-weight: 800;
            }
            .batard{
                font-size: 11vw;
                line-height: 11vw;
                font-weight: 900;
            }
            .amigos{
                font-size: 7.5vw;
                line-height: 7.5vw;
                font-weight: 900;
            }
            .conoce_nuestras{
                font-size: 6vw;
                line-height: 6vw;
                font-weight: 700;
            }
            .gallinas_felices{
                font-size: 7.5vw;
                line-height: 7.5vw;
                font-weight: 900;
                margin-top: 1vw;
            }
        }
        .image{
            width: 100%;
            img{
                float: left;
                width: 100%;
            }
        }
        .cheesy{
            font-weight: 600;
            font-size: 5.5vw;
            text-align: center;
            .cheesy_destaca{
                font-weight: 800;
                font-size: 9vw;
            }
            
        }

        .actions{
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            //margin-top: 6vw;
            .disabled{
                opacity: 0.3;
                cursor: default;
            }
            .bt_cheesy_play,
            .bt_smoothies_play{
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 10px;
                -webkit-box-shadow: -8px 8px 0px 3px rgba(0,0,0,1);
                -moz-box-shadow: -8px 8px 0px 3px rgba(0,0,0,1);
                box-shadow: -8px 8px 0px 3px rgba(0,0,0,1);
                background-color: rgb(${colors.azul_agua});
                color: #FFFFFF;
                border: 2px solid #000000;
                font-size: 5vw;
                line-height: 5vw;
                font-weight: 800;
                text-transform: uppercase;
                padding-left: 5vw;
                padding-right: 5vw;
                height: 13vw;
            }
        }
    }

    .back_marron_tierra{
        background-color: rgba(${colors.marron_tierra}, 1);
    }
    .back_verde_brocoli{
        background-color: rgba(${colors.verde_brocoli}, 1);
    }
    .back_verde_acelga{
        background-color: rgba(${colors.verde_acelga}, 1);
    }
    .back_azul_agua{
        background-color: rgba(${colors.azul_agua}, 1);
    }
    .back_naranja_pimiento{
        background-color: rgba(${colors.naranja_pimiento}, 1);
    }
    .back_amarillo_banana{
        background-color: rgba(${colors.amarillo_banana}, 1);
    }
    .back_blanco_huevo{
        background-color: rgba(${colors.blanco_huevo}, 1);
    }
    .back_trebol{
        background-color: rgba(${colors.trebol}, 1);
    }

    .text_marron_tierra{
        color: rgba(${colors.marron_tierra}, 1);
    }
    .text_verde_brocoli{
        color: rgba(${colors.verde_brocoli}, 1);
    }
    .text_verde_acelga{
        color: rgba(${colors.verde_acelga}, 1);
    }
    .text_azul_agua{
        color: rgba(${colors.azul_agua}, 1);
    }
    .text_naranja_pimiento{
        color: rgba(${colors.naranja_pimiento}, 1);
    }
    .text_amarillo_banana{
        color: rgba(${colors.amarillo_banana}, 1);
    }
    .text_blanco_huevo{
        color: rgba(${colors.blanco_huevo}, 1);
    }
    .text_trebol{
        color: rgba(${colors.trebol}, 1);
    }
        

    .left{
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        //width: 50%;
        width: 100%;
        padding: 35px;
        
        .image{
            display: flex;
            position: relative;
            width: 100%;
            img{
                position: relative;
                height: auto;
                width: 100%;
            }
        }
    }
    .right{
        //width: 50%;
        box-sizing: border-box;
        width: 100%;
        .image{
            display: flex;
            position: relative;
            width: 100%;
            img{
                position: relative;
                height: auto;
                width: 100%;
            }
        }
    }
    .box_texts{
        .title{
            font-size: 36px;
            font-weight: 800;
        }
        .subtitle{
            font-size: 30px;
            font-weight: 800;
        }
        .description{
            //width: 850px;
            font-size: 18px;
            line-height: 24px;
            font-weight: 500;
            margin-top: 20px;
            margin-bottom: 30px;
        }
    }
    .chees_color1{
        color: #f9d02e!important;
    }
    .chees_background{
        background-color: #f9b02e;
    }
`

export const ButtonStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    font-size: 25px;
    line-height: 25px;
    font-weight: 800;
    border-radius: 13px;
    //width: 200px;
    height: 60px;
    padding: 0 25px;
    cursor: pointer;
    &:hover{
    }
`
